import { Component } from '@verndale/core';
import Swiper from 'swiper/js/swiper';

import breakpoints from '../utils/breakpoints';
import StatsGraph from '../components/stats-graph';
import { setAriaLabelledBy } from '../utils/dom';
import { getGenericSliderConfig } from '../utils/slider';

class Stats extends Component {
  setupDefaults() {
    this.dom = {
      $heading: this.el._$('h2'),
      $slides: this.el._$$('.swiper-slide'),
      $swiperContainer: this.el._$('.swiper-container'),
      $cards: this.el._$$('[data-chart-type]'),
      $allCards: this.el._$$('.stats__card'),
      $swiperWrapper: this.el._$('.swiper-wrapper')
    };

    this.isInline = this.el.classList.contains('stats--inline');

    this.initSlider();
    this.dom.$cards.forEach((card) => new StatsGraph(card));
    this.labelCards();
  }

  initSlider() {
    const { $swiperContainer, $slides, $heading } = this.dom;

    const desktopRows = Math.ceil($slides.length / 3);

    if (!this.isInline) {
      const height = desktopRows * 20;
      this.dom.$swiperWrapper.style.setProperty(
        '--stats-row-height',
        `${height}rem`
      );
    }

    const element = this.el;

    new Swiper($swiperContainer, {
      ...getGenericSliderConfig(element, $heading),
      breakpoints: {
        [breakpoints.tablet]: {
          slidesPerColumn: $slides.length,
          slidesPerColumnFill: 'row',
          slidesPerGroup: 1,
          slidesPerView: 1,
          spaceBetween: 0
        },
        [breakpoints.lg]: {
          noSwiping: true,
          slidesPerColumn: desktopRows,
          slidesPerColumnFill: 'row',
          slidesPerView: 3,
          spaceBetween: 30
        }
      },
      on: {
        init() {
          $swiperContainer.classList.remove('loading');
          $swiperContainer.classList.add('loaded');
        }
      }
    });
  }

  labelCards() {
    const { $allCards } = this.dom;

    $allCards.forEach(($card) => {
      const $title = $card._$('.stats__card-heading');
      setAriaLabelledBy($card, $title);
    });
  }
}

export default Stats;
